module.exports = __webpack_public_path__ + "img/vue.8979f75f.png";